import auth from "../../Components/Authenticate";
import setupProperitiesHandler from "../../Security/SetupProperitiesHandler";

const checkUserHasRole = (role) => {
    return auth.getUserRole(role) === role;
}

const checkRolesPermissions = (accessRoles) => {
	if(accessRoles === undefined)
		return false;
    let output = null;
    if (Array.isArray(accessRoles)) {
        for (let accessRole of accessRoles) {

            if (accessRole.and !== undefined) {
                if (output = checkUserHasRole(accessRole.role) && checkRolesPermissions(accessRole.and) === true)
                    break;
            } else if (output = checkUserHasRole(accessRole.role) === true)
                break;
        }

    } else if (typeof accessRoles === "object") {
		if (accessRoles.and !== undefined)
			output = checkUserHasRole(accessRoles.role) && checkRolesPermissions(accessRoles.and);
		else
			output = checkUserHasRole(accessRoles.role);
	}
    
    return output

}


const checkPermissions = (permissions, userMode) => {

    if (permissions === undefined) {
        if (setupProperitiesHandler.get('first_setup') === true)
            return false
        return true
    }

    if (setupProperitiesHandler.get('first_setup') === false && permissions.firstSetup === true)
        return false


    if (permissions.loggedIn === true) {
        if (auth.loggedIn() === false)
            return false;

        if (permissions.userMode !== undefined)
            if (permissions.userMode === "RED" && userMode)
                return false;
            else if (permissions.userMode === "BLUE" && !userMode)
                return false;


        if (permissions.accessRule !== undefined)
            if (!checkRolesPermissions(permissions.accessRule))
                return false

        if (permissions.deinedRule !== undefined)
            if (checkRolesPermissions(permissions.deinedRule))
                return false

    }else if(permissions.loggedIn === false && auth.loggedIn())
        return false

    if (permissions.firstSetup === true && setupProperitiesHandler.get('first_setup') !== true)
        return false

    return true;
}

export default checkPermissions
export {checkRolesPermissions}